import { http } from '@/http'
import { imgServe } from '@/imageServe'

const PATH = 'app/docs/'

class AfastService {
  async register (data) {
    return http.post(PATH.concat('afast-register'), data)
  }

  async uploadFile (doc) {
    const headers = {
      headers: {
        BASE_PATH: process.env.VUE_APP_BASE_API_URL,
        __company: localStorage.getItem('__company')
      }
    }

    return imgServe.post('new-file', { file: doc }, headers)
  }

  async getAllCollabs () {
    return http.get(PATH.concat('combo'))
  }




  async getAllEmployeesWithTrashed () {
    return http.get(PATH.concat('all-with-trashed'))
  }

  async verifyReport (id) {
    return http.get(PATH.concat('reports/').concat(id))
  }

  async generateEmployeeReport (id) {
    if (!id) { return false }

    return http.get(PATH.concat('reports/').concat(id))
  }

  async saveImage (newImg) {
    const headers = {
      headers: {
        BASE_PATH: process.env.VUE_APP_BASE_API_URL,
        __company: localStorage.getItem('__company')
      }
    }

    return imgServe.post('new-file', { file: newImg }, headers)
  }

  async editImage (newImg, imgPath) {
    const headers = {
      headers: {
        BASE_PATH: process.env.VUE_APP_BASE_API_URL,
        __company: localStorage.getItem('__company'),
        __company_path: imgPath
      }
    }

    return imgServe.post('replace-file', { file: newImg }, headers)
  }

  async getEmployeeById (id) {
    return http.get(PATH.concat(id).concat('/employee'))
  }

  async getReports () {
    return http.get(PATH.concat('reports'))
  }

  async getWithDraws () {
    return http.get(PATH.concat(''))
  }

  async editEmployee (id, employeeBody) {
    return http.post(PATH.concat(id).concat('/edit'), employeeBody)
  }

  async deleteEmployee (id) {
    return http.patch(PATH.concat(id).concat('/disable'))
  }
}

export default new AfastService()
export { PATH }
